import { Component } from '@angular/core';

@Component({
    selector: 'app-turbo-graph-table-header',
    templateUrl: './turbo-graph-table-header.component.html',
    styleUrl: './turbo-graph-table-header.component.css',
    standalone: false,
})
export class TurboGraphTableHeaderComponent {}
